import isJwtLikeToken from './isJwtLikeToken';

/**
 * Decide which token (if any) may be injected as Token._sessionToken on /channel-granted.
 *
 * Provider callback query params (e.g. Dotykacka API `token`) must not override a real
 * Dativery session. Only tokens we intentionally bridged (sessionStorage / OAuth state)
 * or JWT-like query tokens are eligible.
 *
 * @param {object} args
 * @param {string|null|undefined} args.stateToken - token from decoded OAuth state
 * @param {string|null|undefined} args.queryToken - URL ?token=
 * @param {string|null|undefined} args.queryAuthToken - URL ?authToken=
 * @param {string|null|undefined} args.sessionStorageToken - consumeChannelGrantToken()
 * @param {boolean} args.hasValidStoredSession - true when localStorage JWT is still valid
 * @returns {string|null}
 */
export function resolveChannelGrantSessionToken({
	stateToken,
	queryToken,
	queryAuthToken,
	sessionStorageToken,
	hasValidStoredSession,
}) {
	if (hasValidStoredSession) {
		return null;
	}

	if (sessionStorageToken) {
		return sessionStorageToken;
	}

	if (stateToken) {
		return stateToken;
	}

	if (isJwtLikeToken(queryToken)) {
		return queryToken;
	}

	if (isJwtLikeToken(queryAuthToken)) {
		return queryAuthToken;
	}

	return null;
}
